/*
 * @Descriptio
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 18:18:36
 * @FilePath: /unifyxp-v2-store-portal/src/router/AuthorizedRoute.tsx
 */
import React from 'react';
import { Route, Redirect } from './Components/Route';
import I18nWrapper from 'src/constrains/I18nWrapper';

function AuthorizedRoute({ component: Component, ...rest }) {
  const isLogin = true; //checkIsLogin();
  const { multipleLanguageProps } = rest;
  // console.log('...AuthorizedRoute', rest);
  return (
    <Route
      {...rest}
      render={(props) =>
        isLogin ? (
          <I18nWrapper _props={props}>
            <Component
              {...props}
              __salesChannelMultiLanguage={multipleLanguageProps}
            />
          </I18nWrapper>
        ) : (
          <Redirect to='/notlogin' />
        )
      }
    />
  );
}
export default AuthorizedRoute;
